$j = jQuery.noConflict();